module.exports = __webpack_public_path__ + "static/media/ca-msb.39c62d27.png";